import { HelpLink } from 'elements/link/HelpLink'
import { useTranslate } from 'react-admin'

const Subtitle = () => {
  const translate = useTranslate()
  return (
    <span>
      {translate(
        'Configure a Lead Capture form for your website or Facebook page, which will automatically create a project within OpenSolar any time a prospective customer fills out the form.'
      )}
      <HelpLink href="https://support.opensolar.com/hc/en-us/articles/12716487543439-How-to-create-and-generate-a-lead-capture-form" />
    </span>
  )
}

const LeadCaptureFormTitle = ({ record, translate, style }) => {
  return (
    <span style={style}>
      {translate('Lead Capture')}: {record ? `"${record.title}"` : ''}
    </span>
  )
}

const CreateLeadCaptureFormTitle = ({ record, translate, style }) => {
  return <span style={style}>{translate('Create Lead Capture')}</span>
}

export default {
  list: { lazy: () => import('./LeadCaptureForms'), component: 'LeadCaptureFormList' },
  create: { lazy: () => import('./LeadCaptureForms'), component: 'LeadCaptureFormCreate' },
  edit: { lazy: () => import('./LeadCaptureForms'), component: 'LeadCaptureFormEdit' },
  options: {
    create: {
      title: <CreateLeadCaptureFormTitle />,
      subtitle: null,
      breadCrumb: 'Create Lead Capture',
    },
    list: {
      title: 'My Lead Capture List',
      subtitle: <Subtitle />,
      breadCrumb: 'Lead Capture',
    },
    edit: {
      title: <LeadCaptureFormTitle />,
      subtitle: null,
      breadCrumb: 'Edit Lead Capture',
    },
  },
}
